const Pricing = {
  label: 'Pricing',
  url: '/pricing',
  heapClass: 'topnav_pricing_v'
}

export default Pricing
